const roomList = r => require.ensure([], () => r(require('@/page/roomList')), 'roomList');

export default [
  {
    path: '/roomList',
    name: 'roomList',
    component: roomList
  }
];



// WEBPACK FOOTER //
// ./src/router/room.js